import React, { useEffect, useState, useRef } from "react";
import { Box, Typography, Divider, Paper } from "@mui/material";
import styles from '../my-data.module.scss';
import { observer } from "mobx-react";
import Section from "./section";
import AddSectionModal from "../category/add-section-modal";
import NavButton from "../../content/shared/components/nav-btn";
import DeleteSectionModal from "../category/delete-section-modal";
import RoundButton from "../../content/shared/components/round-btn";
import { ArrowCircleRight, Edit } from "iconsax-react";
import { LoadingButton } from "@mui/lab";
import SaveIcon from "../../icons/save-icon.png";
import RenameSectionModal from "./rename-section-modal";
import AddCustomFieldModal from "./add-custom-field-modal";


const SectionType = observer(({
    sectionType,
    sections,
    editMode,
    uiStore,
    labels,
    info,
    loading,
    save,
    submit,
    update_info,
    language,
    category,
    updateData,
    onDeleteCategory,
    activeSection,
    sectionErrors,
    inputRefs,
}) => {
    const [show, setShow] = useState(true);
    const [editModeCollapse, setEditModeCollapse] = useState(false);
    const ref = useRef(null);
    const [oldCountOfSections, setOldCountOfSections] = useState(sections.length);
    const [countOfSections, setCountOfSections] = useState(sections.length);

    const handleEditModeCollapse = (id, enable) => {
        if (enable) {
            setEditModeCollapse(true);
        } else {
            setEditModeCollapse(false);
            setCountOfSections(sections.length);
            setOldCountOfSections(sections.length);
        }

        return id
    };

    useEffect(() => {
        if (activeSection) {
            if (activeSection === sections[0]?.name) {
                const yOffset = -210;
                const y = ref.current?.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({ top: y, behavior: 'smooth' });
                handleEditModeCollapse(activeSection, true);
            }
        }

        inputRefs.current.push(ref);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeSection, ref, sections]);

    useEffect(() => {
        if (sections.length !== countOfSections) {
            setOldCountOfSections(countOfSections);
            setCountOfSections(sections.length);
        }

    }, [countOfSections, oldCountOfSections, sections]);

    return (
        <>
            <Paper sx={{ borderRadius: '16px', margin: '20px 0' }} ref={el => ref.current = el}>
                <NavButton children open sx={{
                    mt: '10px', boxShadow: '0px 2px 1px -1px rgb(0 0 0 / 3%)',
                    position: 'sticky', top: '210px', background: '#FFF', zIndex: 3, opacity: 1
                }}>
                    <Typography sx={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        width: '100%',
                        padding: '20px',
                        borderRadius: 0,
                        background: '#FFF'
                    }} fontWeight='700'>
                        <Box sx={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}>
                            <Typography fontWeight={800} fontSize={20}>{sectionType ?? category?.name}</Typography>
                            {sections[0]?.type === 'Custom' &&
                                <RenameSectionModal
                                    uiStore={uiStore}
                                    section={sections[0]}
                                    category={category}
                                    updateData={updateData}
                                    btnStyle='iconOnly'
                                />
                            }
                        </Box>
                        <Box sx={{ display: 'flex' }}>
                            {sections[0]?.name !== 'Name' && sections[0]?.name !== 'Dates' && sections[0]?.repeatable &&
                                <AddSectionModal
                                    uiStore={uiStore}
                                    category={category.name}
                                    sectionName={sections[0]?.name}
                                    sectionType={sections[0]?.type}
                                    updateData={updateData}
                                    type={sectionType}
                                    handleEditModeCollapse={handleEditModeCollapse}
                                />
                            }
                            {sections[0]?.name === 'Dates' &&
                                <AddCustomFieldModal
                                    uiStore={uiStore}
                                    section={sections[0]}
                                    category={category}
                                    updateData={updateData}
                                    type={sectionType}
                                    handleEditModeCollapse={handleEditModeCollapse}
                                />
                            }
                            {show && <>
                                {editModeCollapse ?
                                    !sections[0]?.required && sections[0]?.name !== 'Name' && sections[0]?.name !== 'Dates' &&
                                    <DeleteSectionModal sections={sections[0]} uiStore={uiStore} updateData={updateData}
                                        feedback={() => setShow(false)} category={category}
                                        onDeleteCategory={onDeleteCategory} />
                                    :
                                    <RoundButton
                                        variant="contained"
                                        onClick={() => handleEditModeCollapse(sectionType, true)}
                                        color="lightblue"
                                        className={`${styles.mydataEditBtn} ${styles.hideInMobile}`}
                                        sx={{ borderRadius: '100px', ml: 1 }}
                                    >
                                        <Edit
                                            size="24"
                                            variant="Bulk"
                                        />
                                        <Box className={styles.hideText} sx={{ ml: 1 }}>Edit</Box>
                                    </RoundButton>
                                }
                            </>}
                        </Box>
                    </Typography>
                </NavButton>

                <Box sx={{ padding: '15px 0' }}>
                    {(!!info?.length || editModeCollapse) ?
                        sections.map((section, index) => (
                            <Section
                                key={section?._id}
                                index={index}
                                section={section}
                                editMode={editModeCollapse}
                                uiStore={uiStore}
                                labels={labels?.filter(i => i.section === section?._id)}
                                info={info?.filter(i => i.section === section?._id)}
                                loading={!!loading}
                                save={save}
                                submit={submit}
                                update_info={update_info}
                                language={language}
                                category={category}
                                updateData={updateData}
                                haveData={true}
                                showFirst={category.name === 'Name' || category.name === 'Dates' || (countOfSections > oldCountOfSections ? index === sections.length - 1 : editModeCollapse)}
                                sectionErrors={sectionErrors}
                                ref={inputRefs}
                            />
                        ))
                        :
                        <Box className={styles.sectionHeader} sx={{ textAlign: 'center', display: 'block' }}>
                            No information added yet
                        </Box>
                    }
                </Box>

                {(editModeCollapse || (!!info.filter(i => sections.map(sec => sec._id).includes(i.section)).length)) && !show &&
                    <Box sx={{ mb: 1 }}>
                        <Divider sx={{ m: '16px auto', maxWidth: '800px' }}></Divider>
                    </Box>
                }

                {editModeCollapse &&
                    <Box className={styles.dataDialougeActions}>
                        <LoadingButton loading={!!loading} onClick={() => handleEditModeCollapse(sectionType, false)}
                            variant="outlined"
                            color="secondary" endIcon={<ArrowCircleRight
                                size="24"
                                variant="Bulk"
                            />}>
                            Cancel
                        </LoadingButton>
                        <LoadingButton
                            loading={!!loading}
                            onClick={submit}
                            variant="contained"
                            color="secondary"
                            endIcon={<img src={SaveIcon}
                                alt='Save icon'
                                width={24}
                            />}
                        >
                            Save
                        </LoadingButton>
                    </Box>
                }
            </Paper>
        </>
    );
});

export default SectionType;